<template>
  <div class="cmp-accounting-invoice-report-main-container">
    <div class="main-header">
      <div>
        <h4>{{$t('invoice_report')}}</h4>
        <span>{{$t('fill_in_info_report')}}</span>
      </div>
      <div>
        <button style="margin: 0px" @click="reset" class="dt-button v5 s8">
          {{$t('reset_selection')}}
        </button>
      </div>
    </div>
    <div class="content-container">
      <div class="left-box">
        <div class="box date-box">
          <span>{{$t('time_period')}}</span>
          <div class="date-form">
            <div class="form-content">
              <DatePicker2
                id="start_date"
                style="width: 100%; margin-right: 30px"
                :showLabel="false"
                :placeholder="$t('start_date')"
                :value="reportParam.start_date"
                @input="onDateUpdate"
              />
              <DatePicker2
                id="end_date"
                :showLabel="false"
                :placeholder="$t('end_date')"
                style="width: 100%"
                :value="reportParam.end_date"
                @input="onDateUpdate"
              />
            </div>
            <div class="form-content">
              <Dropdown2
                id="booking_date"
                :placeholder="$t('Booking Date')"
                :disabled="false"
                :showLabel="false"
                :options="bookingDatesTV"
                style="width: 48.5%; margin-right: 30px"
                :selected="reportParam.selectedBookingDate"
                v-on:selectedChange="(e) => onBookingDateChange(e)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="right-box">
        <div class="box">
          <span style="padding-bottom: 5px">{{$t('invoice_project')}}</span>
          <div class="box-form">
            <SelectTree :tree="permTypeTree" @changed="onPermTreeChange" />
          </div>
        </div>
        <div class="check-buttons">
          <img
            @click="onCheckAllCheckbox"
            :src="`static/icons/arrows/${
              selectedAll ? 'checkbox-tick' : 'checkbox'
            }.svg`"
            class="dt-icon checkbox"
          />
          {{$t('select_all')}}
        </div>
        <div style="padding-top: 35px" class="action-box">
          <MenuButton
            @click="onMenuClicked"
            :options="moreReportsTV"
            :label="$t('generate_reports')"
            style="height: 28px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { downloadFile } from "../../../../utility";
import { SelectTree } from "../../../../plugins/select-tree";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { BookingService } from "../../../../modules/booking/services/booking-service";
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import InputField from "../../../../plugins/text-field/input-field";
import { EventHooks } from "../../../../plugins/text-field";
import { mapActions, mapGetters, mapMutations } from "vuex";
import FileDownload from "js-file-download";
import { ReportService } from "../../services/report.service";
import MenuButton from "./menuButton.vue";
import { SharingSettingsService } from "../../../settings/services/sharing-settings.service";
export default {
  components: {
    SelectTree,
    ModalContainer,
    InputField,
    MenuButton,
  },
  props: [],
  data() {
    return {
      reportParam: this.getDefaultReportParam(),
      selectedAll: false,
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      reportData: "reportData",
    }),
    moreReportsTV: function () {
      return [
        { text: "invoice_export_booking", value: "invoice_export_booking" },

        { text: "invoiceline_export", value: "invoiceline_export" },
        {
          text: `${this.reportData.client.display_name} Custom Report`,
          value: "custom_report",
        },
        { text: "invoice_export", value: "invoice_export" },
        { text: "cost_export", value: "cost_export" },
        // { text: "Product Export", value: "Product_Export" },
        {
          text: "new_invoice_export_booking",
          value: "new_invoice_export_booking",
        },
      ];
    },
    bookingDatesTV: function () {
      return [
        { text: "Booking Date", value: "booking_date" },
        { text: "Invoice Date", value: "invoice_date" },
        { text: "Payment Date", value: "payment_date" },
      ];
    },
    date_obj: function () {
      return {
        ...(this.reportParam.selectedBookingDate.value == "payment_date" && {
          payment_start_date: this.reportParam.start_date,
          payment_end_date: this.reportParam.end_date,
        }),
        ...(this.reportParam.selectedBookingDate.value == "booking_date" && {
          booking_start_date: this.reportParam.start_date,
          booking_end_date: this.reportParam.end_date,
        }),
        ...(this.reportParam.selectedBookingDate.value == "invoice_date" && {
          invoice_start_date: this.reportParam.start_date,
          invoice_end_date: this.reportParam.end_date,
        }),
      };
    },
    permTypeTree: function () {
      return (
        (this.reportData.invoice_projects &&
          this.reportData.invoice_projects.map((invoice_project, index) => {
            return {
              text: invoice_project.invoice_project_name,
              value: invoice_project.invoice_project_id,
              selected: invoice_project?.selected,
              expanded: false,
              path: [index],
              children: [],
            };
          })) ||
        []
      );
    },
    reportPayload: function () {
      return {
        ...this.date_obj,
        invoice_project_id: this.reportParam.invoice_project_id,
      };
    },
  },
  created() {},
  mixins: [
    createModalMixin("venueSelectionModal"),
    createModalMixin("promoterSelectionModal"),
  ],
  mounted: function () {},
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.ReportData.UPDATE.ALL]: ActionTypes.ReportData.UPDATE.ALL,
    }),
    onBookingDateChange: function (value) {
      this.reportParam.selectedBookingDate = value;
    },
    onCheckAllCheckbox() {
      this.selectedAll = !this.selectedAll;
      this.reportData.invoice_projects = this.reportData.invoice_projects.map(
        (p) => {
          p.selected = this.selectedAll;
          return p;
        }
      );
      this[ActionTypes.ReportData.UPDATE.ALL]({ reportData: this.reportData });
      this.reportParam.invoice_project_id = this.reportData.invoice_projects
        .filter((e) => e.selected === true)
        .map((e) => e.invoice_project_id);
    },

    onMenuClicked(e) {
      switch (e.value) {
        case "invoice_export":
          this.onInvoiceExportClick();
          break;
        case "invoiceline_export":
          this.onInvoicelineExport();
          break;
        case "cost_export":
          this.onCostExportClick();
          break;
        case "custom_report":
          this.onCustomReportClick();
          break;
        case "new_invoice_export_booking":
          this.onNewInvoiceExportBookingClick();
          break;
        case "invoice_export_booking":
          this.onInvoiceExportBookingClick();
          break;
      }
    },
    onInvoiceExportBookingClick: async function () {
      // const url = ReportService.exportBooking({
      //   ...this.reportPayload,
      // });

      const sharingData = await SharingSettingsService.findSharingData();
      const { ext_api_path, clientID, ext_api_checksum } = sharingData.data;
      const url = `${ext_api_path}${clientID}/action=custom_sql&api_key=${ext_api_checksum}&1=${this.reportParam.selectedBookingDate.value.slice(0, -5)}&2=${this.reportParam.start_date ?? ''}&3=${this.reportParam.end_date ?? ''}&4=${this.reportParam.invoice_project_id ?? ''}&output_format=xls&custom_sql_id=480`;
      downloadFile(url);
    },
    onInvoicelineExport: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        invoiceline: 1,
      });

      downloadFile(url);
    },
    onCustomReportClick: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        report_type: "new",
      });
      downloadFile(url);
    },
    onInvoiceExportClick: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "invoice",
      });

      // const sharingData = await SharingSettingsService.findSharingData();
      // const { ext_api_path, clientID, ext_api_checksum } = sharingData.data;
      // const url = `${ext_api_path}${clientID}/action=custom_sql&api_key=${ext_api_checksum}&1=${this.reportParam.selectedBookingDate.value.slice(0, -5)}&2=${this.reportParam.start_date ?? ''}&3=${this.reportParam.end_date ?? ''}&4=${this.reportParam.invoice_project_id ?? ''}&output_format=xls&custom_sql_id=480`;
      downloadFile(url);
    },
    onCostExportClick: function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "cost",
      });
      downloadFile(url);
    },
    onNewInvoiceExportBookingClick: function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "invioce_xmltemplate",
      });
      console.log(url);
      downloadFile(url);
    },

    onDateUpdate: function ({ name, value }) {
      this.reportParam[name] = value;
    },
    reset: function () {
      this.reportParam = this.getDefaultReportParam();
      this.selectedAll = false;
      this.reportData.invoice_projects = this.reportData.invoice_projects.map(
        (p) => {
          p.selected = false;
          return p;
        }
      );
      this[ActionTypes.ReportData.UPDATE.ALL]({ reportData: this.reportData });
    },
    openModal(e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onPermTreeChange(invoice_projects) {
      console.log("e", invoice_projects);
      this.reportParam.invoice_project_id = invoice_projects
        .filter((e) => e.selected === true)
        .map((e) => e.value);
      this.selectedAll =
        invoice_projects.filter((e) => e.selected).length ==
        invoice_projects.length
          ? true
          : false;
      console.log(":::", this.reportParam.invoice_project_id);
    },
    generateBookingReport() {
      let reportParams = {
        ...this.reportParam,
      };
      Object.keys(reportParams).forEach((key) => {
        if (reportParams[key] == null || reportParams[key] == "") {
          reportParams[key] = "0";
        }
      });
      console.log("reportParams", reportParams);
      BookingService.getBookingReportGenerate(reportParams).then((res) => {
        FileDownload(res.data, "booking_report.xlsx");
      });
    },
    getDefaultReportParam() {
      return {
        start_date: null,
        end_date: null,
        invoice_project_id: null,
        selectedBookingDate: { text: "Invoice Date", value: "invoice_date" },
      };
    },
  },
};
</script>
    
    <style lang="scss" scoped>
.cmp-accounting-invoice-report-main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 190px);
  padding: 20px 10px 10px 10px;
  overflow: hidden;
  max-width: 1245px;

  .main-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 10px;
    h4 {
      color: #282828;
      font-weight: 500;
      text-transform: uppercase;
      opacity: 1;
      font: normal normal bold 13px/18px Roboto;
    }
  }
  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    margin-top: 10px;
    @media (min-width: 320px) and (max-width: 800px) {
      flex-direction: column;
    }
    .left-box {
      width: 100%;
      margin-right: 20px;

      @media only screen and (min-width: 1800px) {
        margin-right: 20px;
        display: flex;
      }
      .box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;
        padding: 5px 15px 15px 15px;
        border-radius: 5px;
        width: 100%;
        margin-bottom: 20px;
        height: fit-content;
        max-width: 600px;
        &:hover {
          --fc2-bc: var(--bc-cblue);
          border: 1px solid #9b9a9a80;
        }
        &.date-box {
          @media only screen and (min-width: 1800px) {
            margin-right: 20px;
          }
        }
        .date-form {
          display: flex;
          flex-direction: column;
          width: 100%;
          .form-content {
            display: flex;
            margin: 5px 0px 5px 2px;
          }
        }
        .box-form {
          display: flex;
          flex-direction: column;
          width: 100%;
          .form-content {
            display: flex;
            margin: 5px 0px 5px 2px;
          }
        }
      }
    }
    .right-box {
      width: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      .box {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border: 1px solid #c8c8c880;
        padding: 5px 15px 35px 15px;
        border-radius: 5px;
        width: 100%;
        overflow: hidden;
        height: 100%;
        max-width: 600px;
        &:hover {
          --fc2-bc: var(--bc-cblue);
          border: 1px solid #9b9a9a80;
        }
        .box-form {
          display: flex;
          flex-direction: row;
          width: 100%;
          //height: 800px;
          overflow: auto;
          scrollbar-width: thin;
          min-height: 100%;
        }
      }
      .check-buttons {
        margin: 5px 0px 0px 15px;
        color: #828282;
      }
      .checkbox {
        width: 25px;
        height: 25px;
        padding: 4px;
      }
      .dt-checkbox.v2 {
        --size: 13px;
        --border-radius: 2px;
        --border-color: var(--border-color);
        --background-color: var(--bc-darker);
        --cm-height: 5px;
        --cm-width: 10px;
        --cm-top: 1px;
        --cm-left: 1px;
        --cm-color: #fff;
        margin-top: 3px;
      }
      img.dt-icon {
        margin: -4px -6px -7px -4px;
      }
      .action-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        .dt-button {
          margin-right: 2px !important;
          padding: 0 10px;
        }
      }
    }
  }
  .v3 {
    font-weight: 400 !important;
    color: #0087ff;
    opacity: 1;
  }
  .menu-container {
    margin-top: 0px !important;
  }
  .fc2-row {
    //--fc2-tf-padding: 0px 0px;
    //--fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .fc2-label {
        display: none;
      }
    }
    .circle {
      margin-left: 10px;
    }
  }
}
</style>